import { render } from "./simpleSms.vue?vue&type=template&id=30fbc392&scoped=true"
import script from "./simpleSms.vue?vue&type=script&lang=js"
export * from "./simpleSms.vue?vue&type=script&lang=js"

import "./simpleSms.vue?vue&type=style&index=0&id=30fbc392&scoped=true&lang=css"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fbc392"]])

export default __exports__